import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const TraceSearchPage = lazy(() =>
  import("@/modules/trace").then((m) => ({ default: m.TraceSearchPage })),
);
const TraceGenealogyPage = lazy(() =>
  import("@/modules/trace").then((m) => ({ default: m.TraceGenealogyPage })),
);

export const traceRoutes: RouteObject[] = [
      {
        element: (
          <RequirePermissions
            codes={[
              PermissionCodes.TrcTraceList, PermissionCodes.TrcTraceManage,
              PermissionCodes.QmsInspectionExecute, PermissionCodes.QmsReleaseDecide,
            ]}
            match="any"
          />
        ),
        children: [
              {
                path: "trc",
                element: (
                  <LazyPage>
                    <TraceSearchPage />
                  </LazyPage>
                ),
              },
              {
                path: "trc/lots/:lotCode",
                element: (
                  <LazyPage>
                    <TraceGenealogyPage />
                  </LazyPage>
                ),
              },
        ],
      },
];
